import { Box, Typography } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  applyEvent,
  CommonOrCommonRetirementFlug,
  FormClassApply,
  FormClassRetire,
  HalfYearExtensionReason,
  OtherBenefitsFlg,
  Prefectures,
  RetireFlowReason,
  RetirementInvoiceOrder,
  RetireReason,
  Status,
  WithholdingSlipKbn,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import TkButton from "../../components/atoms/TkButton";
import TkTable from "../../components/atoms/TkTable";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import { TkGetCode } from "../../utils/TkGetCode";
import "./_style.scss";
import { httpAPI_APP016, httpAPI_APP110, httpAPI_STA003 } from "./api/request";
import {
  maternityLeaveTableHead,
  headListWorkingDayNum,
  salaryTableHead,
  tableList,
  infoHeadTitleList,
  headTitleList4,
} from "./parts";
import {
  changeAmountFormat,
  changeZipcodeFormat,
  isStatusAfterApproval,
} from "../../utils/useTools";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import _ from "lodash";
import { ChildcareActiveListList } from "../../type/contextType/businessContext/IJob_32";

/**
 * SCRW060004_退職情報　登録（登録内容の確認）
 * @return SCRW060004_退職情報　登録（登録内容の確認）
 */
const SCRW060004 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);

  const [stateTableList, setStateTableList] = useState<any>([]);
  const fakeTableLists = useRef(_.cloneDeep(tableList));

  const [bodyList4, setBodyList4] = useState([]);
  const [memo, setMemo] = useState("");
  const [memoError, setMemoError] = useState(false);
  const [inquiryCode, setInquiryCode] = useState<boolean>(false);
  const [latestApplyStatus, setLatestApplyStatus] = useState<any>();
  const [businessType, setBusinessType] = useState<string>("");
  const [nRetireReason, setNRetireReason] = useState<string>("");
  const [fRetireReason, setFRetireReason] = useState<string>("");
  const [corpApplyKbn, setCorpApplyKbn] = useState<"1" | "other" | undefined>();
  const [isSubmitOpen, setIsSubmitOpen] = useState<boolean>(false);
  const [statusInfoTableList, setStatusInfoTableList] = useState<any>([]);
  const [disabledList, setDisabledList] = useState<any>([]);

  const handleInit = async () => {
    // 退職者情報詳細参照API 呼び出し
    try {
      const res = await httpAPI_STA003({
        contractorNo:
          location.state?.contractorNo ?? businessState.common?.contractorNo,
        staffNo: location.state?.staffNo ?? businessState.job_32?.staffNo,
        applyId: location.state?.applyId ?? businessState.job_32?.applyId,
      });

      if (res.resultCd === "I0000") {
        let resArr = fakeTableLists.current;

        for (let index in res) {
          let i = index as keyof typeof res;
          let targetObj = resArr.find((item) => item.keyword === i)!;

          if (targetObj) {
            if (targetObj.keyword?.includes("Kbn")) {
              targetObj.text = TkGetCode(WithholdingSlipKbn, res[i]);
              continue;
            }
            if (targetObj.keyword?.includes("Amt")) {
              targetObj.text = changeAmountFormat(Number(res[i]) ?? 0) + "円";
              continue;
            }
            if (targetObj.keyword?.includes("LengthOfService")) {
              targetObj.text = res[i] + "年";
              continue;
            }
            if (targetObj.keyword?.includes("DeductionPeriodYear")) {
              targetObj.text = res[i] + "年";
              continue;
            }
            if (targetObj.keyword?.includes("DeductionPeriodMonth")) {
              targetObj.text = res[i] + "月";
              continue;
            }

            targetObj.setDefaultValue = res[i];
            targetObj.type === "text" && (targetObj.text = res[i]);
          }
        }
        // 退職者名（新）
        const staffNameKanjiInput = resArr.find(
          (item) => item.keyword === "staffNameKanji"
        )!;
        // 退職者名カナ（新）
        const staffNameKanaInput = resArr.find(
          (item) => item.keyword === "staffNameKana"
        )!;
        // 退職者名漢字
        const bNameKanjiInput = resArr.find(
          (item) => item.keyword === "bNameKanji"
        )!;
        // 退職者名カナ
        const bNameKanaInput = resArr.find(
          (item) => item.keyword === "bNameKana"
        )!;

        if (res?.bNameKanji) {
          staffNameKanjiInput.text = res?.staffNameKanji;
          bNameKanjiInput.text = res?.bNameKanji;
        } else {
          staffNameKanjiInput.showLine = false;
          bNameKanjiInput.text = res?.staffNameKanji;
        }

        if (res?.bNameKana) {
          staffNameKanaInput.text = res?.staffNameKana;
          bNameKanaInput.text = res?.bNameKana;
        } else {
          staffNameKanaInput.showLine = false;
          bNameKanaInput.text = res?.staffNameKana;
        }

        // 退職理由（届出）
        resArr.find((item) => item.keyword === "nRetireReasonCd")!.text =
          TkGetCode(RetireReason, res.nRetireReasonCd);

        // 退職理由（最終）
        let fRetireReasonCd = resArr.find(
          (item) => item.keyword === "fRetireReasonCd"
        )!;
        if (res.nRetireReasonCd === RetireReason["普通退職"]) {
          fRetireReasonCd.showLine = false;
        }
        if (
          res.fRetireReasonCd !== "1" &&
          res.fRetireReasonCd !== "2" &&
          res.fRetireReasonCd !== "3"
        ) {
          fRetireReasonCd.errorMessage = TkPropertyMessageGet("TKMSG_SCR0043E");
          setDisabledList(["受理"]);
        } else {
          fRetireReasonCd.errorMessage = "";
        }
        fRetireReasonCd.disabled = !(
          res.latestApplyStatus === Status["受理待ち"] ||
          res.latestApplyStatus === Status["再受理待ち"]
        );
        fRetireReasonCd.requiredIcon =
          res.latestApplyStatus === Status["受理待ち"] ||
          res.latestApplyStatus === Status["再受理待ち"];
        fRetireReasonCd.onGetValue = (value: any) => {
          setFRetireReason(value);
          if (value !== res.fRetireReasonCd) {
            setDisabledList(["受理"]);
          } else {
            setDisabledList([]);
          }
        };

        // 退職手続きの理由
        if (res.nRetireReasonCd === RetireReason["犯罪等による退職"]) {
          resArr.find(
            (item) => item.keyword === "retireProcedureReason"
          )!.showLine = false;
        }
        resArr.find((item) => item.keyword === "retireProcedureReason")!.text =
          TkGetCode(RetireFlowReason, res.retireProcedureReason);

        // 退職者郵便番号
        resArr.find((item) => item.keyword === "zipcode")!.text =
          changeZipcodeFormat(res.zipcode);

        // 退職者住所
        resArr.find((item) => item.keyword === "address")!.text = `${
          TkGetCode(Prefectures, res.prefectureCd) ?? ""
        }${res.addressCity ?? ""}${res.addressOthers ?? ""}`;

        // ならない月
        let notToBeTable = resArr.find(
          (item) => item.keyword === "notToBeTable"
        )!;
        let checkedList = notToBeTable.checkBoxList
          ?.filter(
            (item: any) =>
              res[item.key as keyof typeof res] === "1" ||
              res[item.key as keyof typeof res] === "3"
          )!
          .map((item: any) => item.label);
        notToBeTable.setDefaultValue = checkedList?.length
          ? checkedList
          : ["無"];

        // 育休状況
        const childcareLeaveList: any = res.childcareLeaveList?.map(
          (item: any) => [
            {
              children: item.childcareLeaveSerialNo,
            },
            {
              children: item.birthday,
              align: "center",
            },
            {
              children: item.startDate,
              align: "center",
            },
            {
              children: item.endDate,
              align: "center",
            },
            {
              children: TkGetCode(YesOrNoFlug, item.papaMamaFlg),
              align: "center",
            },
            {
              children: TkGetCode(
                HalfYearExtensionReason,
                item.halfyearExtensionReason
              ),
            },
            {
              children: TkGetCode(YesOrNoFlug, item.papaChildcareLeaveFlg),
              align: "center",
            },
          ]
        );
        resArr.find((item) => item.keyword === "childcareLeaveInfo")!.node = (
          <TkTable
            headList={maternityLeaveTableHead}
            bodyList={childcareLeaveList}
          />
        );
        // 育休出勤日数
        const childcareActiveListList: any =
          res.childcareLeaveWorkingDayNumList?.map(
            (item: ChildcareActiveListList) => [
              {
                children: `${(item.yearMonth + "").slice(0, 4)}/${(
                  item.yearMonth + ""
                ).slice(4)}`,
                align: "center",
              },
              {
                children: `${item.workingDayNum?.toString()}日`, // 出勤日数
                align: "right",
              },
            ]
          );
        resArr.find(
          (item) => item.keyword === "childcareActiveListList"
        )!.node = (
          <TkTable
            headList={headListWorkingDayNum}
            bodyList={childcareActiveListList}
          />
        );

        // 俸給状況
        const salaryList: any = res.sixMonthsSalaryBeforeApplyList?.map(
          (item) => {
            let yearMonth = item.yearMonth?.toString();
            let details = res.sixMonthsSalaryBeforeApplyDetailList?.filter(
              (i) => i.yearMonth === item.yearMonth
            );
            let allowances = details?.map((detail) => {
              let allowances = res.salaryAdjustmentAllowanceList
                ?.filter(
                  (i) => i.allowanceHisSerialNo === detail?.allowanceHisSerialNo
                )
                .map((i) => i.allowanceName);
              return allowances;
            });
            let allowanceName = allowances?.reduce((acc, currentValue) => {
              if (Array.isArray(currentValue)) {
                return acc?.concat(currentValue);
              } else if (currentValue !== null && currentValue !== undefined) {
                acc?.push(currentValue);
              }
              return acc;
            }, []);
            return [
              {
                children:
                  yearMonth.slice(0, 4) + "年" + yearMonth.slice(4) + "月",
                align: "center",
              },
              {
                children: changeAmountFormat(item.salaryTableAmt ?? 0) + "円",
                align: "right",
              },
              {
                children: Array.from(new Set(allowanceName))?.join("、"),
              },
              {
                children:
                  changeAmountFormat(item.salaryAdjustmentAmt ?? 0) + "円",
                align: "right",
              },
            ];
          }
        );
        resArr.find((item) => item.keyword === "sixMonthsSalaryInfo")!.node = (
          <TkTable
            headList={salaryTableHead}
            bodyList={salaryList}
            headerLeftComponent={<Typography>俸給状況</Typography>}
          />
        );

        // 退職理由
        let retireReason = resArr.find(
          (item) => item.keyword === "retireReason"
        )!;
        const retireReasonText1 = TkGetCode(RetireReason, res.nRetireReasonCd);
        const retireReasonText2 = TkGetCode(
          RetireFlowReason,
          res.retireProcedureReason
        );

        retireReason.text =
          retireReasonText1 && retireReasonText2
            ? `${retireReasonText1}＆${retireReasonText2}`
            : retireReasonText1 || retireReasonText2 || "";

        const hasWageLedger = res.formList?.some(
          (i) => i.formClass === FormClassRetire["賃金台帳"]
        );

        const hasEmploymentContract = res?.formList?.some(
          (i: any) => i.formClass === FormClassRetire["雇用契約書"]
        );

        // 添付書類
        resArr.forEach((item) => {
          if (
            res.nRetireReasonCd ===
            RetireReason["業務上の傷病又は業務上の死亡による退職"]
          ) {
            if (
              item.id === RetireFlowReason["傷病による退職"] ||
              item.id === RetireFlowReason["死亡による退職"]
            ) {
              item.showLine = res.retireProcedureReason === item.id;
            }
          }
          if (item.id === RetireReason["犯罪等による退職"]) {
            item.showLine = res.nRetireReasonCd === item.id;
          }

          if (res.nRetireReasonCd === RetireReason["普通退職"]) {
            retireReason.showLine = false;
            if (!hasWageLedger) {
              resArr.find((item) => item.keyword === "lineTitle")!.showLine =
                false;
            }
            resArr.find(
              (item) => item.keyword === FormClassRetire["賃金台帳"]
            )!.showLine = hasWageLedger;

            resArr.find(
              (item) => item.keyword === FormClassRetire["雇用契約書"]
            )!.showLine = hasEmploymentContract;
          }
        });

        // 福祉医療機構以外からの退職金受け取りの有無
        resArr.find(
          (item) => item.keyword === "prefectureRetirementJoinFlg"
        )!.text = TkGetCode(OtherBenefitsFlg, res.prefectureRetirementJoinFlg);

        // 退職手当金請求の順番
        resArr.find((item) => item.keyword === "retirementInvoiceOrder")!.text =
          TkGetCode(RetirementInvoiceOrder, res.retirementInvoiceOrder);

        // 1枚目/2枚目/3枚目区分が設定されている場合の表示処理
        resArr
          .filter((item) => item.keyword?.includes("page"))
          ?.forEach((item) => {
            res[`${item.id}Kbn` as keyof typeof res] && (item.showLine = true);
          });
        res.formList?.forEach((item) => {
          let targetObj = resArr.find((i) => i.keyword === item.formClass)!;

          if (targetObj) {
            targetObj.dataname = item.formName;
            targetObj.base64filedata = item.fileBase64;
          }

          if (item.formClass === FormClassRetire["賃金台帳"]) {
            targetObj.showLine = !!targetObj;
          }
        });

        // 1枚目/2枚目/3枚目の削除フラグが1の場合の表示処理
        if (res.page1WamDelFlg === "1") {
          let file1 = resArr.find(
            (i) =>
              i.keyword === FormClassRetire["退職所得の源泉徴収票_退職届1枚目"]
          )!;
          file1.type = "text";
          file1.text = "機構にて削除";
        }
        if (res.page2WamDelFlg === "1") {
          let file2 = resArr.find(
            (i) =>
              i.keyword === FormClassRetire["退職所得の源泉徴収票_退職届2枚目"]
          )!;
          file2.type = "text";
          file2.text = "機構にて削除";
        }
        if (res.page3WamDelFlg === "1") {
          let file3 = resArr.find(
            (i) =>
              i.keyword === FormClassRetire["退職所得の源泉徴収票_退職届3枚目"]
          )!;
          file3.type = "text";
          file3.text = "機構にて削除";
        }

        //処理情報リスト
        const statusList: any = [];
        res?.statusList?.forEach((memo: any) => {
          if (memo) {
            const data = [
              {
                children: memo.managerName,
              },
              {
                children: memo.process,
              },
              {
                children: memo.createDate,
              },
              {
                children: memo.processComment,
              },
            ];
            if (statusList) {
              statusList.push(data);
            }
          }
        });
        setStatusInfoTableList(statusList);

        let file = res.formList?.find(
          (item) => item.formClass === FormClassApply["被共済職員退職届"]
        );
        let showLine = isStatusAfterApproval(res.latestApplyStatus);
        const bodyList4: any = [
          [
            {
              children: file ? (
                <TkDownloadLink
                  dataname={TkGetCode(FormClassApply, file.formClass)}
                  base64filedata={file.fileBase64 ?? ""}
                  downloadBase64
                />
              ) : null,
            },
            {
              children: showLine && res.decisionDate,
            },
            {
              children: showLine && res.symbolNo,
            },
          ],
        ];
        setBodyList4(bodyList4);

        setStateTableList([...resArr]);
        setBusinessType(res.businessType!);
        setNRetireReason(res.nRetireReasonCd!);
        setFRetireReason(res.fRetireReasonCd!);
        setCorpApplyKbn(res.corpApplyKbn as keyof typeof corpApplyKbn);
        if (res.latestApplyStatus) {
          setLatestApplyStatus(res.latestApplyStatus);
        }

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    // 契約者（法人）名
    let resArr = fakeTableLists.current;
    resArr.find((item) => item.keyword === "contractorName")!.contractorNumber =
      (location.state?.contractorNo ??
        businessState.common?.contractorNo ??
        "") +
      ":" +
      (location.state?.contractorName ??
        businessState.common?.contractorName ??
        "");
    setStateTableList([...resArr]);

    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let resArr = fakeTableLists.current;
    if (
      fRetireReason !== "1" &&
      fRetireReason !== "2" &&
      fRetireReason !== "3"
    ) {
      resArr.find((item) => item.keyword === "fRetireReasonCd")!.errorMessage =
        TkPropertyMessageGet("TKMSG_SCR0043E");
    } else {
      resArr.find((item) => item.keyword === "fRetireReasonCd")!.errorMessage =
        "";
    }
  }, [fRetireReason, stateTableList]);

  // メモ、チェックボックス入力値変更
  const handleChangeData = (data: any) => {
    if (data?.target?.type === "input") {
      if (
        !data.target.value?.match(
          // eslint-disable-next-line no-control-regex
          /^([^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ])*$/
        )
      ) {
        setMemoError(true);
      } else {
        setMemoError(false);
        setMemo(data.target.value);
      }
    } else {
      setInquiryCode(data?.target?.type);
    }
  };

  const handleRegister = async () => {
    if (
      fRetireReason === "1" ||
      fRetireReason === "2" ||
      fRetireReason === "3"
    ) {
      // 退職理由更新API実行
      try {
        const res = await httpAPI_APP110({
          applyId: location.state?.applyId ?? businessState.job_32?.applyId,
          lastRetireReason: fRetireReason,
        });

        if (res.resultCd === "I0000") {
          setState({
            ...state,
            errorMsgId: "",
          });

          navigate("/SCRW110001");
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
    }
  };

  const handleSubmit = async (
    applyEvent: any,
    validate: boolean,
    formData?: any
  ) => {
    if (validate) {
      if (
        fRetireReason !== "1" &&
        fRetireReason !== "2" &&
        fRetireReason !== "3"
      ) {
        return;
      }
    }

    // 申請状況更新API実行
    try {
      const res = await httpAPI_APP016({
        applyId: location.state?.applyId ?? businessState.job_32?.applyId,
        applyEvent: applyEvent,
        contractorNo: businessState.common?.contractorNo,
        reason: memo,
        inquiryCode: inquiryCode ? "3" : undefined,
        symbolNo: formData
          ? (TkGetCode(
              CommonOrCommonRetirementFlug,
              formData.symbolNumberType
            ) ?? "") +
            "第" +
            (formData.symbolNumber ?? "") +
            "号"
          : "",
        decisionDate: formData?.settlementDate,
        screenId: "SCRW060004",
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res?.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleDialogClose = () => {
    setIsSubmitOpen(false);
  };

  const handleOpenDialogOrSubmit = (value: keyof typeof applyEvent) => {
    if (memoError) {
      return;
    }

    let event = applyEvent[value];
    switch (event) {
      case applyEvent["受理"]:
      case applyEvent["担当者に差戻し"]:
      case applyEvent["課長代理確認"]:
      case applyEvent["上長承認"]:
      case applyEvent["郵送"]:
        handleSubmit(event, true);
        break;
      case applyEvent["契約者に差戻し"]:
      case applyEvent["取下げ"]:
        handleSubmit(event, false);
        break;
      case applyEvent["承認"]:
        setIsSubmitOpen(true);
        break;
    }
  };

  return (
    <Box data-testid="SCRW060004PageForTest" className="SCRW060004">
      {businessType && (
        <TkKikoStepper
          applicationStatus={latestApplyStatus}
          applicationFlowType={businessType === "JOB-31" ? "TYPE2" : "TYPE4"}
          businessType={businessState.common?.businessType}
          corporateApplicationClassification={corpApplyKbn}
        />
      )}

      <TkFakeTable
        list={stateTableList}
        ruleSchema={{
          fRetireReasonCd: {
            required: TkPropertyMessageGet("TKMSG_SCR0043E"),
          },
        }}
        showButton={false}
      />

      <TkMemo
        headList={infoHeadTitleList}
        bodyList={statusInfoTableList}
        showTable={true}
        onChange={handleChangeData}
      />
      {(latestApplyStatus === Status["稟議決裁結果待ち"] ||
        latestApplyStatus === Status["課長代理確認待ち"] ||
        latestApplyStatus === Status["上長承認待ち"] ||
        latestApplyStatus === Status["通知待ち"] ||
        latestApplyStatus === Status["郵送待ち"] ||
        latestApplyStatus === Status["処理完了"]) && (
        <TkTableWithNoLine headList={headTitleList4} bodyList={bodyList4} />
      )}

      <Box className="buttonGroup">
        <TkBackButton
          className="tkBottonMr"
          useBackParam
          navigateParam={{
            applyId: businessState.job_35?.applyId,
          }}
        />
        {(latestApplyStatus === Status["受理待ち"] ||
          latestApplyStatus === Status["再受理待ち"]) &&
          nRetireReason !== RetireReason["普通退職"] && (
            <TkButton className="tkBottonMr" onClick={handleRegister}>
              登録
            </TkButton>
          )}
        <TkViewButtonJudgement
          flowType={businessType === "JOB-31" ? "TYPE2" : "TYPE4"}
          Status={latestApplyStatus as ITkViewButtonJudgementStatus}
          onClick={handleOpenDialogOrSubmit}
          disabledList={disabledList}
        />
        {(latestApplyStatus === Status["受理待ち"] ||
          latestApplyStatus === Status["再受理待ち"] ||
          latestApplyStatus === Status["稟議決裁結果待ち"] ||
          latestApplyStatus === Status["課長代理確認待ち"] ||
          latestApplyStatus === Status["上長承認待ち"] ||
          latestApplyStatus === Status["郵送待ち"] ||
          latestApplyStatus === Status["処理完了"]) && (
          <TkButton onClick={() => handleOpenDialogOrSubmit("取下げ")}>
            取下げ
          </TkButton>
        )}
      </Box>

      <TkApprovalDateSymbolNumberRegistrationDialog
        open={isSubmitOpen}
        onSuccess={(e: any) => handleSubmit(applyEvent["承認"], true, e)}
        onClose={handleDialogClose}
      />
    </Box>
  );
};

export default SCRW060004;
